import BasePlugin from './base-plugin'
import { vjs_find, vjs_mfind } from './utils'

class QualityMenuPlugin extends BasePlugin {
  constructor(player, options = { hdicon: true, minhd: 1080 }) {
    super(player)

    this.options = options

    player.on('sourcesready', (e, sources) => {
      this.initQualityItems(sources)
    })

    this.qualityMenuBtnComp = this.player.ControlBarPlugin().addButton(this.dom.createEl(
      'div',
      {
        className:
          'vjs-quality-button vjs-menu-button vjs-control vjs-button vjs-hidden',
      },
      {
        'tabindex': 0,
        'role': 'button',
        'type': 'button',
        'aria-live': 'off',
        'aria-haspopup': 'true',
        'aria-disabled': 'false',
        'aria-expanded': 'false',
        'aria-label': 'Quality menu',
      },
    ))

    this.qualityMenuBtnEl = this.qualityMenuBtnComp.el()
    this.qualityMenuBtnEl.innerHTML = '<span class="quality-span vjs-no-pointer"></span><span class="vjs-control-text" aria-live="polite">Quality</span><div class="vjs-menu"><div class="vjs-menu-title">Quality</div><ul class="vjs-menu-content vjs-qlist" role="menu"></ul></div>'

    this.qualityMenuBtnEl.onclick = this.qualityMenuBtnEl.ontouchend = (e) => {
      e.stopPropagation()
      const menuEl = vjs_find(this.qualityMenuBtnEl, '.vjs-menu')
      const menuContentEl = vjs_find(menuEl, '.vjs-menu-content')
      const t = vjs_find(e.target, '.vjs-control-text')
      if (this.dom.hasClass(menuEl, 'vjs-lock-showing')) {
        e.target.ariaExpanded = 'false'
        this.dom.removeClass(menuEl, 'vjs-lock-showing')
        if (t) {
          t.removeAttribute('style')
        }
      }
      else {
        this.player.trigger('controlClick', e.target)
        const l = menuEl.getBoundingClientRect()
        const r = this.playerElement.getBoundingClientRect()
        const mx = this.playerElement.offsetHeight - (r.bottom - l.bottom) - 30
        menuContentEl.style.maxHeight = `${mx}px`
        this.dom.addClass(menuEl, 'vjs-lock-showing')
        e.target.ariaExpanded = 'true'
        t.style.opacity = '0'
      }
    }
    this.qualityMenuBtnEl.onmouseover = (e) => {
      const i = vjs_find(e.target, '.vjs-menu')
      if (i) {
        if (this.dom.hasClass(i, 'vjs-lock-showing') !== true) {
          const t = vjs_find(e.target, '.vjs-control-text')
          if (t)
            t.removeAttribute('style')
        }
      }
    }

    this.player.on('controlClick', (e, el) => {
      if (!this.dom.hasClass(el, 'vjs-quality-button')) {
        this.hideQualityMenu()
      }
    })
  }

  initQualityItems = (sources) => {
    this.clearQualityItems()

    let defaultSource = null
    this.dom.addClass(this.qualityMenuBtnEl, this.hiddenClass)
    if (sources.length < 2) {
      return
    }
    const availableSources = []
    for (let c = 0; c < sources.length; c++) {
      if (sources[c].res || sources[c].label) {
        if (defaultSource === null) {
          defaultSource = {
            res: sources[c].res,
            type: sources[c].type,
            src: sources[c].src,
            label: sources[c].label,
          }
        }
        availableSources.push(sources[c])
      }
    }
    let sortedAvailableSources = []
    if (availableSources.length < 2) {
      return
    }
    this.qualityItemLiEls = []
    const menuContentEl = vjs_find(this.qualityMenuBtnEl, '.vjs-menu .vjs-menu-content')
    sortedAvailableSources = availableSources.sort((a, b) => {
      if (!a.res || !b.res) {
        return 0
      }
      else {
        return +b.res - +a.res
      }
    })
    for (let c = 0; c < sortedAvailableSources.length; c++) {
      const currentSource = sortedAvailableSources[c]
      const res = Number.parseInt(currentSource.res, 10)
      let hdHtml = ''
      if (this.options.hdicon && res > this.options.minhd - 1) {
        let label = 'HD'
        if (res > 1079 && this.options.minhd < 1080) {
          label = 'FullHD'
        }
        if (res > 2159) {
          label = '4K'
        }
        hdHtml = `<i class="vjs-hd-icon">${label}</i>`
      }

      if (currentSource.default) {
        defaultSource = currentSource
      }

      const qualityItemLiEl = this.dom.createEl('li', {
        className: currentSource.default ? 'vjs-menu-item item-quality vjs-checked' : 'vjs-menu-item item-quality',
      }, {
        'role': 'menuitemradio',
        'aria-live': 'off',
        'aria-disabled': 'false',
        'aria-label': `Set quality to ${currentSource.label}`,
      })
      qualityItemLiEl.innerHTML = currentSource.label + hdHtml
      qualityItemLiEl.onclick = qualityItemLiEl.ontouchend = (e) => {
        e.preventDefault()
        e.stopPropagation()
        for (let n = 0; n < this.qualityItemLiEls.length; n++) {
          this.dom.removeClass(this.qualityItemLiEls[n], 'vjs-checked')
        }
        this.dom.addClass(qualityItemLiEl, 'vjs-checked')
        this.updateQualityMenuBtn(currentSource.res, currentSource.label)
        this.hideQualityMenu()
        const currentTime = this.player.currentTime()
        const paused = this.player.paused()
        this.player.src(currentSource)
        this.player.load()
        if (currentTime > 0) {
          this.player.currentTime(currentTime)
        }
        if (paused) {
          this.player.pause()
        }
        else {
          this.player.play()
        }
      }
      this.qualityItemLiEls.push(qualityItemLiEl)
      menuContentEl.appendChild(qualityItemLiEl)
    }

    this.dom.removeClass(this.qualityMenuBtnEl, this.hiddenClass)

    if (defaultSource !== null) {
      this.updateQualityMenuBtn(defaultSource.res, defaultSource.label)
      this.player.src(defaultSource)
    }
  }

  hideQualityMenu = () => {
    if (this.qualityMenuBtnEl) {
      const menuEl = vjs_find(this.qualityMenuBtnEl, '.vjs-menu')
      const controlTextEl = vjs_find(this.qualityMenuBtnEl, '.vjs-control-text')
      if (menuEl) {
        this.dom.removeClass(menuEl, 'vjs-lock-showing')
        if (controlTextEl) {
          controlTextEl.removeAttribute('style')
        }
      }
    }
  }

  updateQualityMenuBtn = (res, label) => {
    const s = Number.parseInt(res, 10)
    let o = '<i class="vjs-hd-icon vjs-hd-home vjs-hidden"></i>'
    let l = ''
    if (this.options.hdicon) {
      l = 'HD'
      if (s > 2159)
        l = '4K'
      if (s > this.options.minhd - 1) {
        o = `<i class="vjs-hd-icon vjs-hd-home">${l}</i>`
      }
    }
    vjs_find(this.qualityMenuBtnEl, '.quality-span').innerHTML = label + o
  }

  clearQualityItems = () => {
    vjs_mfind(this.playerElement, '.item-quality').forEach((item) => {
      item.onclick = null
    })
    const items = vjs_mfind(this.playerElement, '.item-quality')
    for (let i = 0; i < items.length; i++) {
      items[i].parentNode.removeChild(items[i])
    }
    vjs_find(this.qualityMenuBtnEl, '.vjs-menu .vjs-menu-content').innerHTML = ''
    this.dom.addClass(this.qualityMenuBtnEl, this.hiddenClass)
  }
}

export default QualityMenuPlugin
